@if (!isFolderOrSubFoldersHasFiles()) {
  <svg [style.width.px]="width()" [style.height.px]="height()" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V16.75C2 17.9927 3.00734 19 4.25 19H23.75C24.9927 19 26 17.9927 26 16.75V6.25C26 5.00734 24.9927 4 23.75 4Z" [style.fill]="folderColor()"/>
    <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V16.75C2 17.9927 3.00734 19 4.25 19H23.75C24.9927 19 26 17.9927 26 16.75V6.25C26 5.00734 24.9927 4 23.75 4Z" fill="url(#paint0_linear)" fill-opacity="0.4"/>
    <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V16.75C2 17.9927 3.00734 19 4.25 19H23.75C24.9927 19 26 17.9927 26 16.75V6.25C26 5.00734 24.9927 4 23.75 4Z" fill="black" fill-opacity="0.06"/>
    <g filter="url(#filter3_d)">
      <path d="M24.75 9H14.75H11.75H3.25C2.00734 9 1 9.00734 1 10.25L2 21.75C2 22.9927 3.00734 24 4.25 24H23.75C24.9927 24 26 22.9927 26 21.75L27 11.25C27 10.0073 25.9927 9 24.75 9Z" [style.fill]="folderColor()"/>
      <path d="M24.75 9H14.75H11.75H3.25C2.00734 9 1 9.00734 1 10.25L2 21.75C2 22.9927 3.00734 24 4.25 24H23.75C24.9927 24 26 22.9927 26 21.75L27 11.25C27 10.0073 25.9927 9 24.75 9Z" fill="url(#paint1_linear)" fill-opacity="0.4"/>
    </g>
    <defs>
      <filter id="filter3_d" x="0" y="7" width="28" height="17" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="-1"/>
        <feGaussianBlur stdDeviation="0.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear" x1="22.6538" y1="-2.34615" x2="10.8846" y2="25" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint1_linear" x1="23.375" y1="6.21154" x2="15.3164" y2="30.5532" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg>
} @else {
  <svg [style.width.px]="width()" [style.height.px]="height()" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="1" width="24" height="23">
      <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V21.75C2 22.9927 3.00734 24 4.25 24H23.75C24.9927 24 26 22.9927 26 21.75V6.25C26 5.00734 24.9927 4 23.75 4Z" [style.fill]="folderColor()"/>
    </mask>
    <g mask="url(#mask0)">
      <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V16.75C2 17.9927 3.00734 19 4.25 19H23.75C24.9927 19 26 17.9927 26 16.75V6.25C26 5.00734 24.9927 4 23.75 4Z" [style.fill]="folderColor()"/>
      <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V16.75C2 17.9927 3.00734 19 4.25 19H23.75C24.9927 19 26 17.9927 26 16.75V6.25C26 5.00734 24.9927 4 23.75 4Z" fill="url(#paint0_linear)" fill-opacity="0.4"/>
      <path d="M23.75 4H14.75L11.75 1H4.25C3.00734 1 2 2.00734 2 3.25V16.75C2 17.9927 3.00734 19 4.25 19H23.75C24.9927 19 26 17.9927 26 16.75V6.25C26 5.00734 24.9927 4 23.75 4Z" fill="black" fill-opacity="0.28"/>
      <g filter="url(#filter0_d)">
        <rect x="4" y="5" width="18" height="18" rx="1" fill="#F8F9FA"/>
        <rect x="4.05" y="5.05" width="17.9" height="17.9" rx="0.95" stroke="#F0F1F2" stroke-width="0.1"/>
      </g>
      <g filter="url(#filter1_d)">
        <rect x="5.5" y="6.5" width="18.5" height="17" rx="1" fill="white"/>
        <rect x="5.55" y="6.55" width="18.4" height="16.9" rx="0.95" stroke="#F0F1F2" stroke-width="0.1"/>
      </g>
    </g>
    <g filter="url(#filter2_d)">
      <path d="M24.75 9H14.75H11.75H3.25C2.00734 9 1 9.00734 1 10.25L2 21.75C2 22.9927 3.00734 24 4.25 24H23.75C24.9927 24 26 22.9927 26 21.75L27 11.25C27 10.0073 25.9927 9 24.75 9Z" [style.fill]="folderColor()"/>
      <path d="M24.75 9H14.75H11.75H3.25C2.00734 9 1 9.00734 1 10.25L2 21.75C2 22.9927 3.00734 24 4.25 24H23.75C24.9927 24 26 22.9927 26 21.75L27 11.25C27 10.0073 25.9927 9 24.75 9Z" fill="url(#paint1_linear)" fill-opacity="0.4"/>
    </g>
    <defs>
      <filter id="filter0_d" x="2" y="2" width="22" height="22" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="-1"/>
        <feGaussianBlur stdDeviation="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.0901961 0 0 0 0 0.113725 0 0 0 0 0.141176 0 0 0 0.11 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter1_d" x="3.5" y="4.5" width="22.5" height="21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter2_d" x="0" y="7" width="28" height="17" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="-1"/>
        <feGaussianBlur stdDeviation="0.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear" x1="22.6538" y1="-2.34615" x2="10.8846" y2="25" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="paint1_linear" x1="23.375" y1="6.21154" x2="15.3164" y2="30.5532" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg>
}
